/**
 * Exposes the sticky header height as --sticky-avoiding-nav on <body> so
 * anchored content can clear it. Moved out of layout/theme.liquid (inline).
 */
const calculateSticky = () => {
	const header = document.querySelector('.shopify-section-header-sticky');
	header && document.body.style.setProperty('--sticky-avoiding-nav', `${header.offsetHeight + 20}px`);
};
document.addEventListener('DOMContentLoaded', () => {
	calculateSticky();
	if (screen?.orientation) screen.orientation.onchange = calculateSticky;
	window.onresize = calculateSticky;
});
